import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as WaybillAction from 'store/actions/waybill';
import WaybillList from 'pages/waybill/query/list';
import { t } from 'i18next';
import FilterBox from 'pages/waybill/query/filter';
import { useHistory } from 'react-router';
import queryString from 'query-string';

// Simplified headers for waybill selection
const getWaybillHeaders = () => [
  {
    text: 'waybill_entry.waybill',
    className: 'fixed-cell left',
  },
  {
    text: 'waybill_entry.shipping_date',
    left: 160,
  },
  {
    text: 'waybill_entry.shipment_type',
  },
  {
    text: 'waybill_entry.shipping_mode',
  },
  {
    text: 'address_book.sender',
  },
  {
    text: 'address_book.receiver',
  },
  {
    text: 'waybill_entry.item_name',
  },
  {
    text: 'waybill_entry.total',
  },
  {
    text: 'waybill_entry.destination',
  },
];

function SelectWaybillDialog({ modalOpen, onToggle, onSelect }) {
  const [searchValue, setSearchValue] = React.useState(null);
  const dispatch = useDispatch();
  const router = useHistory();

  const waybills = useSelector((state) => state.waybill.waybills);

  React.useEffect(() => {
    if (modalOpen) {
      loadData();
    }
  }, [modalOpen]);

  const loadData = (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };
    if (router.location.search) {
      const parsed = queryString.parse(router.location.search);
      query = { ...query, ...parsed };
    }
    dispatch(WaybillAction.getAll(query, value ? value : searchValue ? searchValue : {}));
  };

  const handleSelect = (waybill) => {
    onSelect(waybill);
    onToggle(false);
  };

  const handlePageChange = (page) => {
    const query = queryString.parse(router.location.search);
    query.page = page;
    router.push(`?${queryString.stringify(query)}`);
    loadData(searchValue);
  };

  return (
    <Modal isOpen={modalOpen} size='xl' backdrop={true} toggle={() => onToggle(false)}>
      <ModalHeader toggle={() => onToggle(false)}>
        {t('select')} Waybill
      </ModalHeader>
      <ModalBody>
        <WaybillList
          headers={getWaybillHeaders()}
          data={waybills}
          filter={
            <FilterBox
              onSearch={(value) => {
                loadData(value);
              }}
            />
          }
          onPageChange={handlePageChange}
          onChoose={handleSelect}
          canEdit={() => false}
          canDelete={() => false}
        />
      </ModalBody>
    </Modal>
  );
}

export default SelectWaybillDialog;
